export default __webpack_public_path__ + "static/9-e2b795f9e38bbf8ddef9e3b08aace5e2.png";